
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"allbts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryAllbtsWhereWhereConditions"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderby"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryAllbtsOrderByOrderByClause"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"expire"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allbts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderby"}}},{"kind":"Argument","name":{"kind":"Name","value":"expire"},"value":{"kind":"Variable","name":{"kind":"Name","value":"expire"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"qte"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"qte_fab"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"qte_rest"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"bt_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"no_bt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"machine_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"machine_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statut_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nocmd"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"statut_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"machine_ref"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tier_name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tier_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nbprod"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_label"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"job_order"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"no_of"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"create_uid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"write_uid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cmd_det_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"article_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"label"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":569}};
    doc.loc.source = {"body":"query allbts(\r\n  $where: QueryAllbtsWhereWhereConditions\r\n  $orderby: [QueryAllbtsOrderByOrderByClause!]\r\n  $expire: Int\r\n) {\r\n  allbts(where: $where, orderBy: $orderby, expire: $expire) {\r\n    id\r\n    qte\r\n    qte_fab\r\n    qte_rest\r\n    bt_date\r\n    no_bt\r\n    machine_id\r\n    machine_name\r\n    statut_id\r\n    nocmd\r\n    statut_name\r\n    machine_ref\r\n    tier_name\r\n    tier_id\r\n    nbprod\r\n    product_label\r\n    job_order\r\n    no_of\r\n    create_uid\r\n    write_uid\r\n    details {\r\n      id\r\n      cmd_det_id\r\n      article_id\r\n      code\r\n      label\r\n    }\r\n  }\r\n}\r\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["allbts"] = oneQuery(doc, "allbts");
        
